<div class="row">
  <div class="col-12 order-1 col-sm-12 col-md-12 col-lg-9 order-lg-0">
    <nb-card>
      <nb-card-header
        >{{ isNew ? ("Create" | translate) : ("Update" | translate) }}
        {{ type }} {{ tag?.name }}</nb-card-header
      >
      <nb-card-body>
        <div class="form-group" *ngIf="!isNew">
          <label>{{ "tag_id" | translate }}</label>
          <input
            type="text"
            nbInput
            fullWidth
            placeholder="Id"
            disabled
            [(ngModel)]="tag.id"
          />
        </div>
        <div class="form-group">
          <label>{{ "tag_name" | translate }}</label>
          <input
            type="text"
            nbInput
            fullWidth
            placeholder="Name"
            [(ngModel)]="tag.name"
          />
        </div>
        <div class="form-group">
          <label>{{ "tag_source_id" | translate }}</label>
          <input
            type="text"
            nbInput
            fullWidth
            placeholder="{{ 'tag_source_id' | translate }}"
            [(ngModel)]="tag.sourceId"
          />
        </div>
        <div class="form-group">
          <label>{{ "tag_group" | translate }}</label>
          <app-parent-tag-select
            [value]="tag.parentId"
            (valueChange)="tag.parentId = $event"
          ></app-parent-tag-select>
        </div>
        <div class="form-group">
          <label>{{ "tag_expiry_date" | translate }}</label
          ><br />
          <input
            nbInput
            fullWidth
            placeholder="{{ 'pick_date' | translate }}"
            [nbDatepicker]="dateTimePicker"
            [(ngModel)]="expiration"
          />
          <nb-date-timepicker
            #dateTimePicker
            singleColumn
            format="dd.MM.yyyy HH:mm"
          ></nb-date-timepicker>
        </div>
      </nb-card-body>
    </nb-card>
  </div>

  <div class="col-12 order-0 col-sm-12 col-md-12 col-lg-3 order-lg-1">
    <nb-card style="position: sticky; top: 110px">
      <nb-card-body>
        <button
          (click)="save()"
          nbButton
          size="medium"
          fullWidth
          status="primary"
        >
          <nb-icon icon="save-outline"></nb-icon
          >{{ (isNew ? "create" : "save") | translate }}
        </button>

        <br /><br />

        <button
          [disabled]="isNew"
          (click)="handleClickDelete()"
          nbButton
          size="medium"
          fullWidth
          status="primary"
        >
          <nb-icon icon="trash-outline"></nb-icon>{{ "delete" | translate }}
        </button>

        <br /><br />

        <button
          [disabled]="isNew || tag.group"
          (click)="testpush()"
          nbButton
          size="medium"
          fullWidth
          status="primary"
        >
          <nb-icon icon="navigation-2-outline"></nb-icon
          >{{ "test_push" | translate }}
        </button>

        <br />
        <br />
        <br />

        <button
          [disabled]="isNew"
          nbButton
          size="medium"
          fullWidth
          status="primary"
          routerLink="info"
        >
          <nb-icon icon="info-outline"></nb-icon>{{ "info" | translate }}
        </button>

        <br />
        <br />

        <button
          nbButton
          (click)="location.back()"
          size="medium"
          fullWidth
          status="primary"
        >
          <nb-icon icon="arrow-back-outline"></nb-icon>{{ "back" | translate }}
        </button>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<!-- Modals-->

<ng-template #deleteDialog let-context let-ref="dialogRef">
  <nb-card accent="primary">
    <nb-card-header>{{ "delete" | translate }}</nb-card-header>
    <nb-card-body
      >{{ "delete_question" | translate }} {{ context.tag.name }}?</nb-card-body
    >
    <nb-card-footer class="d-flex">
      <button
        nbButton
        size="medium"
        fullWidth
        status="primary"
        class="mr-2"
        (click)="ref.close()"
      >
        {{ "close" | translate }}
      </button>
      <button
        nbButton
        size="medium"
        fullWidth
        status="primary"
        (click)="context.delete(); ref.close()"
      >
        {{ "delete" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>
